module.exports = __webpack_public_path__ + "media/KZ-ZHA.df9ec0fa.ogg";